<script setup lang="ts">
import type { NuxtError } from '#app'

import LogoDocueBlack from '~/assets/images/logo_docue_black.svg?url'

defineProps<{
  error: NuxtError
}>()

const { t } = useI18n()
</script>

<template>
  <div class="relative flex min-h-screen min-w-full flex-col items-center gap-5 py-10">
    <p class="mt-10 text-lg text-gray-600">
      {{ error.status }}
    </p>

    <h1 class="text-center text-5xl font-bold lg:text-7xl">
      {{ t('errorPage.title') }}
    </h1>

    <p class="text-center text-lg text-gray-600 empty:hidden">
      {{ error.statusText || error.message || t('unknown-error') }}
    </p>

    <UiButton
      color="destructive"
      class="mt-5"
      size="lg"
      as-child
    >
      <a href="/">
        {{ t('errorPage.cta') }}
      </a>
    </UiButton>

    <img
      :src="LogoDocueBlack"
      class="mb-2 mt-auto"
    >
  </div>
</template>
